import {
  showAllEdgeLabels,
  hideAllEdgeLabels,
  resetZoom,
  downloadCytoJSON,
  downloadCytoPNG,
} from './ActionButtonsFunctions';
import SharedButton from '@/global/Button/Button';
import { ArrowDownTrayIcon } from '@heroicons/react/24/solid';
import { useState } from 'react';

const possibleCytoLayouts = ['circle', 'concentric', 'grid', 'breadthfirst', 'random', 'cose'];

export default function CytoscapeActionButtons({
  changeSelectedLayout,
  selectedLayout,
  names,
  parent,
  chartInfo,
}) {
  const [layoutSelect, setLayoutSelect] = useState(false);
  const toggleDropdown = () => setLayoutSelect(prev => !prev);

  const handleSelectLayout = layout => {
    changeSelectedLayout(layout);
    setLayoutSelect(false);
  };

  return (
    <div className="flex flex-col md:flex-row justify-center gap-2 mb-4">
      <div className="flex gap-2 justify-center">
        <SharedButton variant="secondary" onClick={showAllEdgeLabels}>
          Show edge labels
        </SharedButton>
        <SharedButton variant="secondary" onClick={hideAllEdgeLabels}>
          Hide edge labels
        </SharedButton>
      </div>
      <div className="flex gap-2 justify-center">
        <SharedButton variant="secondary" onClick={resetZoom}>
          Reset Zoom
        </SharedButton>
        <SharedButton
          variant="secondaryOutline"
          onClick={() => downloadCytoJSON({ names, parent, chartInfo })}
        >
          <ArrowDownTrayIcon className="w-4 h-4 mr-1" /> Download (JSON)
        </SharedButton>
      </div>
      <div className="flex gap-2 justify-center">
        <SharedButton
          variant="secondaryOutline"
          onClick={() => downloadCytoPNG({ names, parent, chartInfo })}
        >
          <ArrowDownTrayIcon className="w-4 h-4 mr-1" /> Download (PNG)
        </SharedButton>
        <div className="dropdown">
          <SharedButton
            variant="gradient"
            size="sm"
            arrow={layoutSelect ? 'up' : 'down'}
            onClick={toggleDropdown}
          >
            Select layout: {selectedLayout}
          </SharedButton>
          {layoutSelect && (
            <div className="dropdown-menu absolute mt-1 bg-white shadow-md rounded-md z-50">
              {possibleCytoLayouts.map(layout => (
                <div
                  key={layout}
                  className={`dropdown-item select-layout-options block px-3 py-1 cursor-pointer ${
                    selectedLayout === layout ? 'active bg-blue-100' : ''
                  }`}
                  onClick={() => handleSelectLayout(layout)}
                >
                  {layout}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
